import { useDispatch } from "react-redux";
import styles from "./statusModal.module.css";
import { useEffect } from "react";
import { hideModal } from "../../features/statusModal/statusModal";
import TextWrapper from "../textWrapper/TextWrapper";
import XImage from "../../assets/images/svgs/cancel-svgrepo-com (2).png";

const StatusModal = ({ status, message, id }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(hideModal({ id }));
    }, 5000);
    return () => clearTimeout(timer);
  }, [dispatch, id]);

  return (
    <div className={`${styles.modal} ${styles[status]}`}>
      <img
        src={XImage}
        alt="X"
        className={styles.XImage}
        onClick={() => dispatch(hideModal({ id }))}
      />
      <TextWrapper textStyle={"textModal"}>{message}</TextWrapper>
    </div>
  );
};

export default StatusModal;
